import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorService {
  private metadataErrorSubject = new BehaviorSubject<{error: string, details: string} | null>(null);
  public metadataError$ = this.metadataErrorSubject.asObservable();

  setMetadataError(error: string, details: string): void {
    this.metadataErrorSubject.next({ error, details });
  }

  clearMetadataError(): void {
    this.metadataErrorSubject.next(null);
  }

  getCurrentMetadataError(): {error: string, details: string} | null {
    return this.metadataErrorSubject.value;
  }
}
